export default __webpack_public_path__ + "static/Tengable-intro.webmhd-47c7595c35bb17d7facfc431134d4ba1.webm";